import { createContext, useState } from 'react';

export const TemplateContext = createContext();

const TemplateProvider = props => {
	const [selectedTemplate, setSelectedTemplate] = useState(null);
	const [dockerState, setDockerState] = useState('listing');
	const [createObj, setCreateObj] = useState({});
	const [activeSection, setActiveSection] = useState('general_details');
	const [addPopupToggler, setAddPopupToggler] = useState(null);
	const [savePopupState, setSavePopupState] = useState(null);

	const reset = () => {
		setSelectedTemplate(null);
		setDockerState('listing');
		setCreateObj({});
		setAddPopupToggler(null);
		setSavePopupState(null);
	};

	return (
		<TemplateContext.Provider
			value={{
				selectedTemplate,
				dockerState,
				createObj,
				activeSection,
				addPopupToggler,
				savePopupState,
				setSavePopupState,
				setSelectedTemplate,
				setDockerState,
				setCreateObj,
				setActiveSection,
				setAddPopupToggler,
				reset
			}}
		>
			{props.children}
		</TemplateContext.Provider>
	);
};

export default TemplateProvider;
